/**
 * Dropdown values for enabling/disabling Instacart optimization
 */
export enum InstacartOptimizationStatus {
  Enabled = 'enabled',
  Disabled = 'disabled'
}
